export const PERMISSIONS_ROUTE = {
  name: 'Permissions',
  path: 'permissions',
};
